export default "__VITE_ASSET__BiQCf_lg__"